import React, {useState, useEffect, useRef, useContext} from 'react';
import { saveState } from 'providers/localStorage';
import RestProvider from 'providers/RestProvider';
import {properties, texts, flagAc} from './ListadoProcedimientosData';
import { properties as appProperties, compProperties } from '../../../AppData';
import Botonera from '../../commons/botonera/BotoneraVertical';
import Table from '../../commons/table/Table';
import SearchBar from '../../commons/searchBar/SearchBar';
import Pager from '../../commons/pager/Pager';
import {Grid, CircularProgress, Backdrop, Snackbar} from '@material-ui/core';
import {customStyle} from './ListadoProcedimientosStyle';
import {properties as propertiesSearchBar} from '../../commons/botonera/BotoneraVerticalData';
import {Alert} from '@material-ui/lab';
import AvisosCriticos from '../../commons/avisosCriticos/avisosCriticos'
import Avisos from '../../commons/avisos/Avisos'
import AppContext from 'AppContext';
import {properties as botoneraVerticalData  }  from './../../commons/botonera/BotoneraVerticalData';
import {properties as cloudConfigProperties, getContextFromUrl} from 'config/Config'
import AuthProvider from 'providers/authProvider';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import useProtectedRoutes from '../../../providers/useProtectedRoutes';
import useApp from 'AppFunctions';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState, deleteState } from 'redux/slicers/kingdomOV3Slice';

function ListadoProcedimientos() {
    const { quitarTildes, deleteCacheLocalStorage } = useApp();
    const { objDataPopup } = useProtectedRoutes();
    const dispatch = useDispatch();
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const flagAvisosCriticos = useSelector((state) => state.kingdomOV3.flagAvisosCriticos);
    const misTramites = useSelector((state) => state.kingdomOV3.misTramites);
    const protectedRoute = useSelector((state) => state.kingdomOV3.protectedRoute);

    const [mostrarPopup, setMostrarPopup] = useState(false);

    useEffect(()=> {
        (protectedRoute !== undefined && protectedRoute !== '') && setMostrarPopup(true);
    },[protectedRoute]);

    const handleConfirmar = () => {
        dispatch(deleteState({filnedName: 'protectedRoute'}));
        setMostrarPopup(false);
    }

    //HOOKS
    const [tipoProcedimientos, setTipoProcedimientos] = useState([]);
    const [tipoProcedimientosPct2, setTipoProcedimientosPct2] = useState([]);
    const [tipoProcedimientosPct3, setTipoProcedimientosPct3] = useState([]);
    const [procedimientos, setProcedimientos] = useState([]);
    const [procedimientosFiltrados, setProcedimientosFiltrados] = useState([]);
    const [currentPage, setCurrentPage] = useState(properties.INIT_PAGE);
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const refDefaultButtonBotonera = useRef(null);
    const refAutocomplteSearchBar = useRef(null);
    const [phoneSelectedOption, setPhoneSelectedOption] = useState(propertiesSearchBar.DEFAULT_BUTTON);
    const [isLoading, setIsLoading] = useState(false);
    const [errores, setErrores] = useState([]);
    const [mostrarAvisoC, setMostrarAvisoC] = useState(true);
    const [sistemasUsuario, setSistemasUsuario] = useState([]);
    const [idProcedimientoPCT3, setIdProcedimientoPCT3] = useState([]);   
    const context = useContext(AppContext);
    const {crudOperation, crudOperationsType} = RestProvider();
    const {checkCloudProperties} = AuthProvider();
    const [numMostrar, setNumMostar] = useState('5');
    const [anchorEl, setAnchorEl] = useState(null);

    let style = customStyle();
    let btnMisTramites = document.querySelector(`#${botoneraVerticalData.idMistramites}`);
    
    //LLAMADAS

    useEffect(() => {
        setIsLoading(true); 
        mostrarAC();
        updateFormat();
        getDataProcedimientos();
        resetLocalStorage();
        context.updateTitlePage(texts.PAGE_TITLE);   
        compruebaUsuarioIsLogin();
        return () => window.removeEventListener('resize', updateFormat);
    }, []) ;

    /*Se crea efecto para mostrar el listado de procedimientos del usuario logado, siempre y cuando se cumpla la condición.
    Se recupera el valor booleano almacenado en localStorage que se ha insertado desde el fichero menuUsuario.js para indicar que se ha pulsado
    el botón mis trámites desde el menú usuario*/
    useEffect(() => {
        if (btnMisTramites && misTramites) {
            //Paso 1. Se pulsa el botón Mis Trámites de la botonera vertical
            btnMisTramites.click();        
            //Paso 2. Se elimina la variable del contexto
            dispatch(deleteState({filnedName: 'misTramites'}));
        }
    }, [procedimientos]);

    const compruebaUsuarioIsLogin = () => {
        if (infoUsuario !== undefined && infoUsuario !== '') {
            setIsLogin(true);
            getDataProcedimientosUsuario();
        } else {
            setIsLogin(false);
        }
    }; 

    useEffect(() => {
        if(context.sesion && context.sesion !== appProperties.SESION_CADUCADA){
            compruebaUsuarioIsLogin();
        } 
    }, context.sesion);

    // Efecto aplicado para eliminar los posibles datos cacheados en localStorage
    useEffect(() => {
        deleteCacheLocalStorage();
    },[]);

    /**
     * @function getDataTipoProcedimientos Función que obtiene los tipos de procedimientos.
     * Contando con los procedimientos de PCT2 y PCT3
     * @returns Devuelve un array con los tipos de procedimientos
     */
    const getDataTipoProcedimientos = async () => {
        let respuesta = [], tipoProcedimientosPCT2 = [], tipoProcedimientosPCT3 = [];        

        await checkCloudProperties(100);

        // Paso 1. Se obtienen los tipos de procedimientos a mostrar (desde cloudConfig)
        let listTiposAMostrar = cloudConfigProperties['LISTA_TIPO_PROCEDIMIENTOS'].split(',');

        // Paso 2. Se obtienen los tipos de procedimientos de PCT2
        tipoProcedimientosPCT2 = await getTipoProcedimientosPCT2();

        // Paso 3. Se obtienen los tipos de procedimientos de PCT3
        tipoProcedimientosPCT3 = await getTipoProcedimientosPCT3();

        // Paso 4. Unificación de los procedimientos de PCT2 y PCT3      
        respuesta = unirTiposProcedimientos(tipoProcedimientosPCT2, tipoProcedimientosPCT3);

        /* Paso 5. Filtrado de procedimientos a través de los procedimientos obtenidos de ambos sistemas (PCT2 y PCT3) 
         y los tipos de procedimientos definidos en cloudConfig */
        let procFiltrados = filtrarTiposProcedimientos(listTiposAMostrar, respuesta);
        
        // Paso 6. Se ordena el array, estableciendo el tipo de procedimiento Otros en último lugar
        let respuestaOrdenada = mostrarUltimoTipoProcOtros(procFiltrados);

        // Paso 7. Se insertan los tipos de procedimientos
        setTipoProcedimientos(respuestaOrdenada);
        dispatch(insertNewState({filnedName: 'tipoProcedimientos', value: respuestaOrdenada}));
        setIsLoading(false);
        return respuestaOrdenada;
    }

    /**
     * @function getTipoProcedimientosPCT2 Función que obtiene los tipos de procedimientos provenientes de la PCT2
     * @returns Devuelve un array con los tipos de procedimientos obtenidos
     */
    const getTipoProcedimientosPCT2 = async () => {
        let tipoProcedimientosPCT2 = [];
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: properties.URL_TIPO_PROCEDIMIENTOS, method: 'get' }).then(response => {
            tipoProcedimientosPCT2 = response.data;
            setTipoProcedimientosPct2(tipoProcedimientosPCT2);
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'});
        });
        return tipoProcedimientosPCT2;
    }

    /**
     * @function getTipoProcedimientosPCT3 Función que obtiene los tipos de procedimientos provenientes de la PCT3
     * @returns Devuelve un array con los tipos de procedimientos obtenidos
     */
    const getTipoProcedimientosPCT3 = async () => {
        let tipoProcedimientosPCT3 = [];
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_TIPO, { url: '', method: 'get'}).then(response => {
            let listTipoProcPCT3 = response.data.content;
            // El objeto no contiene la clave descripcion, se añade con el valor de la clave-valor nombre
            for (const tipoProc of listTipoProcPCT3) {
                Object.assign(tipoProc, {descripcion: tipoProc.nombre});
            }
            tipoProcedimientosPCT3 = listTipoProcPCT3;
            setTipoProcedimientosPct3(tipoProcedimientosPCT3);
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'})
        });
        return tipoProcedimientosPCT3;
    }
    
    /**
     * @function filtrarTiposProcedimientos Función que realiza el filtrado de los tipos de procedimientos a mostrar.
     * Comprueba los procedimientos de las dos listas, si un procedimiento de tiposProcedimiento está contenido en listTiposAMostrar,
     * se devuelve en la lista final de los tipos de procedimientos a mostrar.
     * @param {*} listTiposAMostrar Listado de tipos de procedimientos de los cuales se deben mostrar
     * @param {*} tiposDeProcedimiento Listado de procedimientos obtenidos
     * @returns Array con los procedimientos a mostrar
     */
    const filtrarTiposProcedimientos = (listTiposAMostrar, tiposDeProcedimiento) =>{
        let tiposFiltrados = [];

        tiposDeProcedimiento &&
            tiposDeProcedimiento.forEach((tipoProc) => {
                let i = 0;
                let encontrado = false;

                while(i < listTiposAMostrar.length && !encontrado) {
                    let tipoProcMostrar = listTiposAMostrar[i];
                    if (tipoProc.descripcion.toLowerCase()===tipoProcMostrar.toLowerCase()) {
                        tiposFiltrados.push(tipoProc);
                        encontrado = true;
                    }
                    i++;
                }
            });
        return tiposFiltrados;
    }

    /**
     * @function mostrarUltimoTipoProcOtros Función que establece el tipo de procedimiento "Otros" en último lugar
     * @param {*} tiposDeProcedimiento Listado de tipos de procedimientos
     * @returns Array con el listado de tipos de procedimientos ordenados, apareciendo en último lugar el tipo de procedimiento "Otros"
     */
    const mostrarUltimoTipoProcOtros = (tiposDeProcedimiento) => {
        let tipoProcOtros;
        let tiposDeProcedimientoOrd = [];
    
        tiposDeProcedimiento &&
            tiposDeProcedimiento.forEach((tipoProc) => {
                if (tipoProc.descripcion.toLowerCase() === "otros") {
                    tipoProcOtros = tipoProc;
                } else {
                    tiposDeProcedimientoOrd.push(tipoProc);
                }
            });

        tipoProcOtros &&
            tiposDeProcedimientoOrd.push(tipoProcOtros);
        return tiposDeProcedimientoOrd;
    }

    /**
     * @function getDataProcedimientos Función que obtiene los procedimientos de RPS, PCT2 y PCT3
     */
    const getDataProcedimientos = async () => {
        let respuesta = [];
        let procedimientosPct2 = []
        let procedimientosPct3 = [];
        let procedimientosRps = [];

        // Paso 1. Obtención de los procedimientos de la PCT2
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: '', method: 'get'}).then(response => {
            procedimientosPct2 = response.data;
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'});
        });

        // Paso 2. Obtención de los procedimientos de la PCT3
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PCT_PROCEDIMIENTO, { url: properties.URL_PROCEDIMIENTOS_OV, method: 'get'}).then(response => {
            procedimientosPct3 = response.data;
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'});
        });
        // Paso 3. Obtención de los procedimientos de RPS
        procedimientosRps = await getProcedimientosRPS();

        // Paso 4. Unión de los procedimientos de la PCT2 y RPS 
        await unirProcedimientosRpsPct2(procedimientosPct2, procedimientosRps, respuesta);

        // Paso 5. Unión de los procedimientos de la PCT3 y RPS
        await unirProcedimientosRpsPct3(procedimientosPct3, procedimientosRps, respuesta);

        // // Paso 6. Obtención de los tipos de procedimientos
        await getDataTipoProcedimientos();

        // Paso 7. Filtrado de procedimientos duplicados;
        let procFiltrados = await filtrarProcedimientosDuplicados(respuesta);

        respuesta = await ordenarProcedimientos(procFiltrados);

        // Paso 8. Ordenación de los procedimientos
        respuesta  = await ordenarProcedimientos(respuesta);

        setProcedimientos(respuesta);
        setProcedimientosFiltrados(respuesta);

        compruebaUsuarioIsLogin(respuesta);
        setIsLoading(false);
    }

    /**
     * @function getFechaActual Función que obtiene la fecha actual
     * @returns 
     */
    const getFechaActual = async () => {
        let fechaObtenida =  null;

        await crudOperation(crudOperationsType.CUSTOM, properties.DATE_TIME, { url:'', method: 'get'}).then(response => {
            fechaObtenida = response.data;
        });

        let hora = fechaObtenida.substring(0,2);
        let minutos = fechaObtenida.substring(3,5);
        let segundos = fechaObtenida.substring(6,8);
        let dia = fechaObtenida.substring(9,11);
        let mes = fechaObtenida.substring(12,14);
        let anyo = fechaObtenida.substring(15,19);
      
        let fechaActual = new Date();
        fechaActual.setHours(hora);
        fechaActual.setMinutes(minutos);
        fechaActual.setSeconds(segundos);
        fechaActual.setDate(dia);
        fechaActual.setMonth(mes - 1);
        fechaActual.setFullYear(anyo);

        return fechaActual;
    }

    /**
     * @function ordenarProcedimientos Función que realiza el ordenado de los procedimientos
     * La ordenación se realiza de la siguiente forma:
     * 1.- Procedimientos activos
     * 2.- Procedimientos inactivos (cerrado plazo de presentación)
     * La ordenación se basa en los siguientes criterios: Fecha de inicio de presentación más reciente a la actual y en caso de igualdad de fecha orden alfabético.
     * @param {*} procedimientos 
     * @returns 
     */
    const ordenarProcedimientos = async (procedimientos) => {
        let procedimientosOrdenados = [];
        let procedimientosActivos = [];
        let procedimientosInactivos = [];
        let fechaActual = await getFechaActual();

        if (procedimientos !== null && procedimientos.length !== 0) {

            // Clasificación de procedimientos, entre activos e inactivos
            for (const proc of procedimientos) {
                let fechaMayorFinPresentacion = null;

                // Se obtiene la fecha mayor de fin de presentación
                if (proc.fechaMayorFinPresentacion !== undefined && proc.fechaMayorFinPresentacion !== null) {
                    fechaMayorFinPresentacion = new Date(proc.fechaMayorFinPresentacion);
                }
                
                ((fechaMayorFinPresentacion !== null && fechaActual !== null) && fechaMayorFinPresentacion > fechaActual)
                    ? procedimientosActivos.push(proc)
                    : procedimientosInactivos.push(proc);
            }
            
            // Ordenación de los procedimientos activos e inactivos
            procedimientosActivos = await ordenacionProcedimientos(procedimientosActivos);
            procedimientosInactivos = await ordenacionProcedimientos(procedimientosInactivos);
            //Asignación de los procedimientos ordenados
            procedimientosOrdenados = procedimientosActivos.concat(procedimientosInactivos);
            
        } else {
            procedimientosOrdenados = procedimientos !== null && procedimientos;
        }
        return procedimientosOrdenados;
    }

    /**
     * @function ordenacionProcedimientos Función que realiza el ordenado de los procedimientos
     * Criterios de ordenación: Fecha más reciente (campo fechaMayorInicioPresentacion) y en caso de que las fechas sean iguales por orden alfabético (campo descripción)
     * @param {*} procedimientos 
     * @returns 
     */
    const ordenacionProcedimientos = async (procedimientos) => {
        procedimientos.sort(function ordenarBloque(a, b) {
            // Evaluación por fecha
            if (new Date(a.fechaMayorInicioPresentacion) > new Date(b.fechaMayorInicioPresentacion)) {
              return -1;
            } else if (new Date(a.fechaMayorInicioPresentacion) < new Date(b.fechaMayorInicioPresentacion)) {
              return 1;
            // En caso de que la fecha sea igual, se evalúa por orden alfabético
            } else if (a.descripcion < b.descripcion) {
              return -1;
            } else if (a.descripcion > b.descripcion) {
              return 1;
            } else {
              return 0;
            }
          });
        return procedimientos;
    }

    const filtrarProcedimientosDuplicados = async (respuesta) => {
        let respuestaSinDuplicados = [];
        let index;
        let duplicado;
        respuesta.forEach(procedimiento => {
            index = 0;
            duplicado = false;
            while(index < respuestaSinDuplicados.length && !duplicado){
                if(respuestaSinDuplicados[index].descripcion === procedimiento.descripcion){
                    duplicado = true;
                }
                index++;
            }

            if(!duplicado){
                respuestaSinDuplicados.push(procedimiento);
            }
        });
       
        return respuestaSinDuplicados;
    }

    const getProcedimientosRPS = async () => {
        let procedimientosRps = [];

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROC_RPS, { url: properties.URL_PROC_RPS, method: 'get'}).then(response => {
            if (response.data !== undefined && response.data !== null) {
                for (const proc of response.data) {
                    proc.codigoRPA = proc.codigoRPA.toString();
                    procedimientosRps.push(proc);
                }
            }
        }).catch(function (error) {
            procedimientosRps = [];
            //handleSetMessage({ex: {err}, severity: 'error'})
        });
        return procedimientosRps
    }

    const unirProcedimientosRpsPct2 = async (procedimientosPct2, procedimientosRps, respuesta) => {
        let listInfoRpsPct2 = [];

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_RPS, { url: '/', method: 'get'}).then(response => {
            listInfoRpsPct2 = response.data;
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'})
        });

        await checkCloudProperties(100);
        let entorno = cloudConfigProperties['REACT_APP_CONFIG_PROFILE'];

        for (let index = 0; index < procedimientosPct2.length; index++) {
            let procedimientoPct2 = procedimientosPct2[index];
            let infoRpsPct2 = listInfoRpsPct2.filter((element)=>
                (element.nombreProcedimiento ? element.nombreProcedimiento.toLowerCase() : '') === (procedimientoPct2.nombre ? procedimientoPct2.nombre.toLowerCase() : '')
            );
            
            if(infoRpsPct2 && infoRpsPct2[0]){
                let estado = calcularCampoEstadoRps(listInfoRpsPct2, infoRpsPct2[0].codigoRpa, procedimientosPct2, 'PCT2');
                let procedimientoRps = procedimientosRps.filter((element)=> element.codigoRPA === infoRpsPct2[0].codigoRpa);
                if(procedimientoRps && procedimientoRps[0]){
                    let procedimiento = {
                        ...procedimientoPct2,
                        "descripcion": procedimientoRps[0].nombre,
                        "descripcionCorta": procedimientoRps[0].familia,
                        "fechaPlazo": procedimientoPct2.plazo,
                        "plazo": estado
                    }
                    respuesta.push(procedimiento);
                }else if(procedimientoPct2.externo){
                    Object.assign(procedimientoPct2, {fechaPlazo: procedimientoPct2.plazo});
                    procedimientoPct2.plazo = calcularCampoEstado(procedimientoPct2.plazo);
                    respuesta.push(procedimientoPct2);
                }else if(!entorno.includes('pro')){
                    Object.assign(procedimientoPct2, {fechaPlazo: procedimientoPct2.plazo});
                    procedimientoPct2.plazo = calcularCampoEstado(procedimientoPct2.plazo);
                    procedimientoPct2.informacion = 'NO INCLUIDO EN RPS';
                    respuesta.push(procedimientoPct2);
                }
            }else if(procedimientoPct2.externo){
                Object.assign(procedimientoPct2, {fechaPlazo: procedimientoPct2.plazo});
                procedimientoPct2.plazo = calcularCampoEstado(procedimientoPct2.plazo);
                respuesta.push(procedimientoPct2);
            }else if(!entorno.includes('pro')){
                Object.assign(procedimientoPct2, {fechaPlazo: procedimientoPct2.plazo});
                procedimientoPct2.plazo = calcularCampoEstado(procedimientoPct2.plazo);
                procedimientoPct2.informacion = 'NO INCLUIDO EN RPS';
                respuesta.push(procedimientoPct2);
            }
        }       
    }

    const unirProcedimientosRpsPct3 = async (procedimientosPct3, procedimientosRps, respuesta) => {
        await checkCloudProperties(100);
        let entorno = cloudConfigProperties['REACT_APP_CONFIG_PROFILE'];

        for (const proc of procedimientosPct3) {
            if (proc.codigoRps) {
                let procedimientoRps = procedimientosRps.filter((element) => element.codigoRPA === proc.codigoRps);
                let estado = calcularCampoEstadoRps(procedimientoRps, proc.codigoRps, procedimientosPct3, 'PCT3');
                if (procedimientoRps && procedimientoRps[0]) {
                    let procedimiento = {
                        ...proc,
                        "descripcion": procedimientoRps[0].nombre,
                        "descripcionCorta": procedimientoRps[0].familia,
                        "fechaPlazo": proc.plazo,
                        "plazo": estado
                    }
                    respuesta.push(procedimiento);
                } else if (!entorno.includes('pro')){
                    proc.informacion = 'NO INCLUIDO EN RPS';
                    Object.assign(proc, {fechaPlazo: proc.plazo});
                    proc.plazo = calcularCampoEstado(proc.plazo);
                    respuesta.push(proc);
                }
            } else if (!entorno.includes('pro')){
                proc.informacion = 'NO INCLUIDO EN RPS';
                Object.assign(proc, {fechaPlazo: proc.plazo});
                proc.plazo = calcularCampoEstado(proc.plazo);
                respuesta.push(proc);
            }  
        }
    }

    const calcularCampoEstadoRps = (listInfoRpsPct, codigoRpa, procedimientosPct, pct) => {
        let estado = "Sin Información";
        let varCodRpa = pct === 'PCT2' ? 'codigoRpa' : 'codigoRPA';

        // Se comprueba si el código RPA de los procedimientos obtenidos existen en los procedimientos de RPS
        let listInfoMismoRpa = listInfoRpsPct.filter( infoRpsPct =>
            (infoRpsPct[varCodRpa] ? infoRpsPct[varCodRpa].toLowerCase() : '') 
                === 
            (codigoRpa ? codigoRpa.toLowerCase() : '')
        );

        // Condición si solo existe un procedimiento en RPS
        if (listInfoMismoRpa && listInfoMismoRpa.length === 1) {
            let listProcedimientoPct = null;

            listProcedimientoPct = procedimientosPct.filter(procedimientoPct => 
                pct === 'PCT2' 
                    ?   (
                            (procedimientoPct.nombre ? procedimientoPct.nombre.toLowerCase() : '')
                                ===
                            (listInfoMismoRpa[0].nombreProcedimiento ? listInfoMismoRpa[0].nombreProcedimiento.toLowerCase() : '')
                        )
                    :   (
                            (procedimientoPct.codigoRps === listInfoMismoRpa[0].codigoRPA)
                        )
            );

            if (listProcedimientoPct && listProcedimientoPct[0]) {
                estado = calcularCampoEstado(listProcedimientoPct[0].plazo);
            }
        // Condición si existe más de un procedimiento en RPS   
        } else if (listInfoMismoRpa && listInfoMismoRpa.length > 1) {
            let listProcedimientoPctMismoRpa = [];

            listInfoMismoRpa.forEach(infoMismoRpa => {
                let listProcedimientoPct = procedimientosPct.filter((procedimientoPct) =>
                    pct === 'PCT2'
                        ?   (
                                (procedimientoPct.nombre ? procedimientoPct.nombre.toLowerCase() : '')
                                    ===
                                (infoMismoRpa.nombreProcedimiento ? infoMismoRpa.nombreProcedimiento.toLowerCase() : '')
                            )
                        :   (
                                (procedimientoPct.codigoRps === infoMismoRpa.codigoRPA)
                            )
                );
                if (listProcedimientoPct > 1 && listProcedimientoPct[0]) {
                    listProcedimientoPctMismoRpa.push(listProcedimientoPct[0]);
                }
            });

            let i = 0;
            while (i < listProcedimientoPctMismoRpa.length && estado !== texts.ESTADO_ABIERTO) {
                estado = calcularCampoEstado(listProcedimientoPctMismoRpa[i].plazo);
                i++;
            }
        }
        return estado;
    }

    const calcularCampoEstado = (plazo) => {
        let estado = "";

        if(plazo){
            let dia = plazo.substring(3, 5);
            let mes = plazo.substring(0, 2);
            let anio = plazo.substring(plazo.length - 4, plazo.length);
            let fechaFormato = dia + '/' + mes + '/' + anio;
            let plazoObtenido = new Date(fechaFormato);
            let fechaActual = new Date();

            if(plazoObtenido >= fechaActual){
                estado = texts.ESTADO_ABIERTO
            }else{
                estado = texts.ESTADO_CERRADO
            }
        }else{
            estado = "Sin Información"
        }   

        return estado;
    }

    
    /**Llamada al microservicio de moad-api-proxy para recuperar los procedimientos asignados al usuario logado */
    const getDataProcedimientosUsuario = async () => {

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: properties.URL_SISTEMAS_SUBVF2 + "/"+ infoUsuario.interesadoNif, method: 'get'}).then(response => {
            setSistemasUsuario(response.data);
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'})
        })

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_GESTION_EXPEDIENTE, { url: properties.RESOURCE_GETPROCEDIMIENTOS_INTERESADO + "/" + infoUsuario.interesadoNif, method: 'get'}).then(response => {
            setIdProcedimientoPCT3(response.data);
        }).catch(function (error) {
            handleSetMessage({ex: {error}, severity: 'error'})
        })
        setIsLoading(false);
    }

    //FUNCIONES

    /**Método que actualiza la página actual en la que se encuentra */
    const paginate = pageNumber => {
        let previousPage = currentPage;
        setCurrentPage(pageNumber);
        return previousPage
    }
    
    /**Método que actualiza los procedimientos que se están mostrando actualmente */
    const updateSearch = value => {
        setProcedimientosFiltrados(value);  
        setNumMostar(5);
    }

    /**Método que actualiza el elemento selecionado en el select de tipos
    ***de procedimientos en versión movil*/
    const updatePhoneSelectedOption = value => {
        setPhoneSelectedOption(value);
    }

    /**Método que actualiza el numero de filas que muestra la tabla*/
    const handleChange = (event) => {
        setAnchorEl(event.currentTarget);
        setNumMostar(event.target.value);
        setCurrentPage(properties.INIT_PAGE);
      };

    /**
     * @function unirTiposProcedimientos Función que une los tipos de procedimientos de PCT2 y PCT3.
     * En caso de que ya exista un procedimiento, solo coge uno.
     * @param {*} tipoProcPCT2 
     * @param {*} tipoProcPCT3 
     * @returns Array con los tipos de procedimientos existentes en los 2 sistemas (PCT2 y PCT3)
     */
    const unirTiposProcedimientos = (tipoProcPCT2, tipoProcPCT3) => {
        
        tipoProcPCT2 && tipoProcPCT2.map((procPCT2) => {
            let esNuevo = true;

            if (procPCT2.descripcion && procPCT2.id) {
                tipoProcPCT3.map(procPCT3 => {
                    if (quitarTildes(procPCT3.nombre).toLowerCase() === quitarTildes(procPCT2.descripcion).toLowerCase()) {
                        esNuevo = false;
                    }     
                });
                if (esNuevo) {
                    let obj = {
                        id: procPCT2.id,
                        nombre: procPCT2.descripcion,
                        descripcion: procPCT2.descripcion
                    }
                    tipoProcPCT3.push(obj);
                }   
            }
        });
        return tipoProcPCT3;
    }


    /**Método que renderiza el paginador solo en versión ordenador */
    const renderPager = () =>{
        if(!isPhoneVersion){
            return <Grid item>
                <Pager recordsPerPage={numMostrar} totalRecords={procedimientosFiltrados.length} currentPage={currentPage} 
                paginate={paginate} numFilasMostrar={numMostrar} registrosTotales={procedimientosFiltrados.length} handleChange={handleChange}
                numFilasPersonalizado={true} disabledRegistros={disabledNumregistros} anchorEl={anchorEl}/>

            </Grid>
        }   
    }

    //**Gestiona los mensajes de por pantalla para errores, info, etc */
    const handleSetMessage = (error) => {
        setErrores(oldArray => [...oldArray, error]);
    }

    

    /**Método que capta el tamaño de la ventana y actualiza actualiza
    ***el hook que controla cuando se da el salto a versión movil*/
    const updateFormat = () => {

        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };   

    const mostrarAC = () =>{
        if(flagAvisosCriticos != flagAc.VISTO){
            setMostrarAvisoC(true);
        }else{
            setMostrarAvisoC(false);
        }
    }

    const resetLocalStorage = () => {
        // Estados a eliminar
        const stateToDelete = ['procedimientoActual', 'convocatoriaSeleccionada', 'perfilSeleccionado', 'resourceFormNuevaSolicitud',
            'solicitudActual', 'recibi', 'idExpTrewa', 'numRegistroAries', 'pdfSolicitud', 'convocatoriasProcedimientoPCT',
            'urlProcedenciaProcedimiento', 'entidadSeleccionada', 'entidadesDeAlta'
        ];

        // Se recorre el array que contiene los estados a eliminar y se procede a su eliminación
        for (let i = 0; i < stateToDelete.length; i++) {
            dispatch(deleteState({filnedName: stateToDelete[i]}));
        }
    }

    const cerrarSesionDesdePct2 = () => {
        let url = window.location.href; 
        if(url.includes(properties.URL_CERRAR_SESION_DESDE_PCT2)){
            let botonCerrarSesion = document.getElementById(properties.ID_BOTON_CERRAR_SESION);
            if(botonCerrarSesion){
                botonCerrarSesion.click();
            }
        }
    }

    window.addEventListener('resize', updateFormat);

    const indexOfLastRecord = currentPage * numMostrar;
    const indexOfFirstRecord = indexOfLastRecord - numMostrar;
    let disabledNumregistros = false;
    if(procedimientosFiltrados.length<5){
        disabledNumregistros = true;
    }
    let procedimientosMostrados = procedimientosFiltrados.slice(indexOfFirstRecord, indexOfLastRecord);

    cerrarSesionDesdePct2();

    //RENDER

    return (
    
        <main>
            <Avisos />
            <Grid container direction='column'  justify='space-between'>
                <Grid item>
                </Grid>
                <Grid container direction={isPhoneVersion ? 'column-reverse' : 'row'} justify='space-between'>
                    <Grid item className={style.gridPageTitle}>
                        <h2 id="tituloPagina" className={style.pageTitle}>{texts.PAGE_TITLE}</h2>
                    </Grid>
                    <Grid item className={isPhoneVersion ? style.gridSearchBarResponsive: style.gridSearchBar}>
                        <div className='x'><SearchBar data={procedimientos} updateSearch={updateSearch} updatePhoneSelectedOption={updatePhoneSelectedOption} refDefaultButtonBotonera={refDefaultButtonBotonera} refAutocomplteSearchBar={refAutocomplteSearchBar} paginate={paginate} isPhoneVersion={isPhoneVersion}/></div> 
                    </Grid>
                </Grid>

                <div className={style.backgroundRectangle}>
                    <section>
                        <Grid container direction='row'  justify='space-around'>
                            <section className={style.gridBotonera} aria-label={properties.ALABEL_FILTRADO}>
                                <Botonera dataUsuario={sistemasUsuario} data={procedimientos} buttonsPropiedades={tipoProcedimientos} phoneSelectedOption={phoneSelectedOption} updatePhoneSelectedOption={updatePhoneSelectedOption} updateSearch={updateSearch}  refDefaultButtonBotonera={refDefaultButtonBotonera} refAutocomplteSearchBar={refAutocomplteSearchBar} paginate={paginate} isLogin={isLogin} isPhoneVersion={isPhoneVersion} tipoPct2={tipoProcedimientosPct2} tipoPct3={tipoProcedimientosPct3} dataUsuarioPCT={idProcedimientoPCT3}/>
                            </section>
                            <section className={isPhoneVersion ? style.gridTableResponsivePager : style.gridTablePager} aria-label={properties.ALABEL_LISTADO}>
                                <Grid item className={style.gridTable}>
                                    <Table options={isPhoneVersion ? procedimientosFiltrados : procedimientosMostrados} isPhoneVersion={isPhoneVersion}></Table>
                                </Grid>
                                {renderPager()}
                            </section>
                        </Grid>
                    </section>
                </div>
            </Grid> 
            <Backdrop className={style.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Confirmacion
                {...objDataPopup}
                accionConfirmacion={handleConfirmar}
                mostrar={mostrarPopup}
                isPhoneVersion={isPhoneVersion}
                botonera={compProperties.CONFIR_SOLO_ACEPTAR}
                quitarImg={false}
                tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
                isPopUpPdf={false}
                textBotonConfirmarPersonalizado={false}
                isImagenPersonalizada={true}
                centrarContenido={true}
                isTextoEnriquecido={true}
                imagen={`${getContextFromUrl()}` + properties.POPUP_ICON}
            />

            {(mostrarAvisoC && !mostrarPopup) && 
                <AvisosCriticos/>
            }

            {errores.map(error => ( 
                <Snackbar open={error.ex.error.response} autoHideDuration={properties.DISPLAY_TIME_ERROR} onClose={() => setErrores([])}>
                    <Alert
                        severity={error.severity}
                        variant="filled"
                        className={style.classAlerta}
                        >
                        {error.ex.error.response && error.ex.error.response.data && error.ex.error.response.data.messageDescription ? error.ex.error.response.data.messageDescription : texts.SERVER_ERROR_MSG}
                    </Alert>
                </Snackbar>
            ))}
        </main>
    )
}

export default ListadoProcedimientos
